// @flow
import type { StateType } from '../reducers';
import type { FileType } from './reducer';

export const filesSelector = (state: StateType): FileType[] => state.files;

export const paymentInvoiceSelector = (state: StateType, paymentId?: string): ?FileType => {
  if (!paymentId) {
    return null;
  }
  return filesSelector(state).find((file: FileType) => file.fileName.includes(paymentId));
};
